import {AdminWidget} from "../../widget/AdminWidget";
import {EducationFormComponent} from "../../components/admin/EducationForm/EducationFormComponent";

export const EducationForm = () => {
    return(
        <AdminWidget>
            <EducationFormComponent />
        </AdminWidget>
    )
}